"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CleverLeaf = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8 6.79S4.105 4.497 4.105 2.07C4.105-.235 7.343-.723 8 1.155c.657-1.878 3.895-1.39 3.895.915 0 2.617-3.552 4.529-3.895 4.72zm6.787 1.534c1.972.626 1.46 3.708-.961 3.708-2.75 0-4.757-3.38-4.957-3.708 0 0 2.407-3.708 4.957-3.708 2.421 0 2.933 3.083.961 3.708zm-7.656 0c-.2.327-2.207 3.708-4.957 3.708-2.42 0-2.934-3.082-.96-3.708-1.974-.625-1.46-3.708.96-3.708 2.55 0 4.957 3.708 4.957 3.708zm.063 5.373V9.86h1.612V16H7.194v-2.303z",
  className: "fill"
}));
var _default = exports.default = CleverLeaf;